<template>
  <vue-dropzone id="dropzone" :options="dropzoneOptions" :useCustomSlot=true>
    <div class="dropzone-custom-content">
      <h3 class="dropzone-custom-title font-weight-light">{{ lang("Belge yüklemek için buraya sürükleyin!") }}</h3>
      <div class="text-muted">... veya tıklayarak bilgisayarınızdan seçin </div>
    </div>
  </vue-dropzone>
</template>

<script>
  import lang from './lang';
  import vue2Dropzone from 'vue2-dropzone';

  const template = () => `
    <div class="dz-preview dz-file-preview">
      <div class="dz-filename" style="padding-right: 20px"><span data-dz-name></span></div>
      <div class="dz-details">
        <div class="dz-size" data-dz-size></div>
      </div>
      <div class="dz-progress"><span class="dz-upload" data-dz-uploadprogress></span></div>
      <div class="dz-success-mark"><span>✔</span></div>
      <div class="dz-error-mark"><span>✘</span></div>
      <div class="dz-error-message"><span data-dz-errormessage></span></div>
      <div data-dz-remove class="btn btn-warning cancel">İptal</div>
      <div data-dz-remove class="btn btn-danger delete">Sil</div>
    </div>
  `

  export default {
    name: 'Dropzone',
    components: {
      vueDropzone: vue2Dropzone,
    },
    methods: {
      lang: (str) => lang(str),
      success: function (file, response) {
      },
    },
    data: function () {
      return {
        locale: window.locale,
        greeting: 'Hello',
        dropzoneOptions: {
          url: 'https://httpbin.org/post',
          thumbnailWidth: 150,
          previewTemplate: template(),
        }
      };
    },
  }
</script>

<style scoped>
  .vue-dropzone {
    min-height: 138px;
  }

  .dropzone-custom-content {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    text-align: center;
  }

  .dropzone-custom-title {
    margin-top: 0;
    color: #00b782;
  }

  .subtitle {
    font-weight: bold;
  }
</style>
